import TestarossaSwitch from './TestarossaSwitch'

export default TestarossaSwitch
// eslint-disable-next-line import/export
export * from './TestarossaSwitch'
